import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { PaymentProvider } from '../../CheckoutTypes';
import {
  trackPayPalDisplay,
  trackPayPalOrder,
} from '../../../tracking/event/index';

declare global {
  interface Window {
    paypal: any;
  }
}

export type PayPalButtonColour = 'gold' | 'blue' | 'silver' | 'white' | 'black';

interface Props {
  amount: string;
  onSuccess: (id: string) => void;
  // beforeSubmitErrorMessage is for validation just before we call the payment provider
  beforeSubmitErrorMessage?: (paymentProvider: PaymentProvider) => string;
  buttonColour?: PayPalButtonColour;
}

const Button = ({
  amount,
  onSuccess,
  buttonColour = 'silver',
  beforeSubmitErrorMessage = () => '',
}: Props) => {

  const PayPalButton = typeof window !== "undefined" ? window.paypal.Buttons.driver('react', {React,ReactDOM}) : null;

  useEffect(() => {
    trackPayPalDisplay();
  }, []);

  function createOrder(data, actions) {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: amount,
          },
        },
      ],
      application_context: {
        shipping_preference: 'NO_SHIPPING',
      },
    });
  }

  function approveOrder(orderID) {
    trackPayPalOrder();
    onSuccess(orderID);
  }

  return (
    <div data-testid="paypal-rest-wrapper" className="paypal-button">
      <PayPalButton
        onClick={() => !beforeSubmitErrorMessage('paypal')}
        createOrder={(data, actions) => createOrder(data, actions)}
        onApprove={(data, actions) => approveOrder(data.orderID)}
        style={{ color: buttonColour, height: 40 }}
      />
    </div>
  );
};

export default Button;
